/*
    @module print
    Providing window.print() as an action
 */
define('shared/util/providers/actions/print',['shared/util/registers/ActionProvider'], function(ActionProvider){
    var done = false;
    return {
        provide: function(){
            if ( done ) {
                return;
            }

            var provider = {
                id: 'provider-print',
                type: 'page',
                actions: {
                    'print': function () {
                        window.print();
                    }
                }
            };

            ActionProvider.instance.register( provider );

            done = true;
        }
    };
    
});
